import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { TIME_OUT_MODAL } from '../../containers/modal/modal-types';

import { useInterval } from '../../lib/hooks';
import { printTime } from '../../lib/utils';
import { setRemainingTime, terminateSection, tick } from '../../actions/status';
import { connect } from 'react-redux';
import { showModal } from '../../actions/modal';
import { currentSectionIsLast, getCurrentSection } from '../../lib/status';

export const Time = styled.span`
    display: flex;
    min-width: 80px;
    font-size: 28px;
    font-weight: 600;
    color: var(--gray800);

    ${(props) =>
        props.time < 300 &&
        css`
            color: var(--red500);
        `};
`;

export const Timer = ({ setRemainingTime, showModal, status, terminateHomework, terminateSection, tick }) => {
    const [time, setTime] = useState(status.remainingTime);
    const isTimerRunning = () =>
        time > 0 &&
        !status.finished &&
        (status.started || (!status.id && status.expiringAssignment) || (status.paused && status.expiringAssignment) || status.resumed);

    useInterval(
        () => {
            if (isTimerRunning()) {
                setTime(time - 1);
                tick();
            }
        },
        isTimerRunning() ? 1000 : null,
    );

    useEffect(() => {
        const sections = status.sections;

        const handleTimeout = async () => {
            if (!sections || currentSectionIsLast(sections)) {
                if (!!sections && currentSectionIsLast(sections) && !getCurrentSection(sections).completed) {
                    await terminateSection(status.id, true);
                }
                await terminateHomework();
            }

            showModal(TIME_OUT_MODAL);
        };

        if (
            status.remainingTime <= 0 &&
            !status.httpStatus.updating &&
            !status.finished &&
            (!sections || !sections[sections.length - 1].completed)
        ) {
            handleTimeout();
        }
    }, [
        showModal,
        status.id,
        status.finished,
        status.httpStatus.updating,
        status.remainingTime,
        status.sections,
        terminateHomework,
        terminateSection,
    ]);

    useEffect(() => {
        if (Number.isInteger(status.resetTimerValue)) {
            setTime(status.resetTimerValue);
            setRemainingTime(null);
        }
    }, [status.resetTimerValue, setRemainingTime]);

    return <Time time={time}>{printTime(time)}</Time>;
};

Timer.propTypes = {
    setRemainingTime: PropTypes.func,
    showModal: PropTypes.func,
    status: PropTypes.object,
    terminateHomework: PropTypes.func,
    terminateSection: PropTypes.func,
    tick: PropTypes.func,
};

const actionsCreator = {
    setRemainingTime,
    showModal,
    terminateSection,
    tick,
};

const stateToProps = (state) => {
    return {
        status: state.status,
    };
};

export default connect(stateToProps, actionsCreator)(Timer);
